export default class Command {
    constructor(item) {
        this.id = item != null ? item.id : ''
        this.companyId = item != null ? item.companyId : ''
        this.emailAddress = item != null ? item.emailAddress.address : ''
        this.firstName = item != null ? item.firstName : ''
        this.lastName = item != null ? item.lastName : ''
        this.groupIds = item != null ? item.groups.map(x=> x.id) : []
        this.permissionIds = item != null ? item.permissions.map(x=> x.id) : []
        this.modules = item != null ? item.modules : ''        
    }
}